import { Internship } from '@backrs_ui/common-ui/src/models/internship';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';
import { selectIsSharedSessionActive } from '../sharedSession/sharedSession';
import type { RootState } from '../store';

export const internshipApi = createApi({
  reducerPath: 'internshipApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getInternshipById: build.query<Internship, string>({
      queryFn: async (id, queryApi, _extraOptions, baseQuery): Promise<{ data: Internship }> => {
        const state = queryApi.getState() as RootState;
        const isSharedSession: boolean = selectIsSharedSessionActive(state);

        const url: string = isSharedSession
          ? `shared/solution-session/internship/${id}`
          : `content-search/internship/${id}`;

        return baseQuery({ url }) as Promise<{ data: Internship }>;
      },
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const {
  useGetInternshipByIdQuery,
  usePrefetch: usePrefetchInternship,
  util: { resetApiState },
} = internshipApi;
